import styled from "@emotion/styled";
import { PaginationItem as Item, Pagination } from "@mui/material";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const PaginationList = styled(Pagination)`
  ul {
    flex-wrap: nowrap;
    gap: 16px;
  }
`;

export const PaginationItem = styled(Item)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid ${({ theme }) => theme.colors.secondary.minor};
    color: ${({ theme }) => theme.colors.secondary.minor};

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
        width: 60px;
        height: 60px;
        font-size: 20px;
        font-weight: 500;
    }

    svg {
        stroke: ${({ theme }) => theme.colors.white};
    }

    &.MuiPaginationItem-root {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        padding: 0;
        margin: 0;
        font-size: 20px;
        font-weight: 500;
        border: 1px solid ${({ theme }) => theme.colors.secondary.minor};
        color: ${({ theme }) => theme.colors.secondary.minor};

        @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
            width: 36px;
            height: 36px;
            font-size: 16px;
            font-weight: 400;
        }


    &.Mui-selected{
        background-color: transparent;
        border-color: ${({ theme }) => theme.colors.black};
        color: ${({ theme }) => theme.colors.black};
    };
    &.MuiPaginationItem-previousNext {
        padding: 0 12px;
        background-color: ${({ theme }) => theme.colors.black};
    };
    &.Mui-disabled {
        opacity: 1;
        background-color: transparent;
        path {
        stroke: ${({ theme }) => theme.colors.secondary.minor};
    },
    },
    }

,
`;

export const Ellipsis = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary.minor};
  border: 1px solid ${({ theme }) => theme.colors.secondary.minor};
  border-radius: 50%;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    width: 60px;
    height: 60px;
    font-size: 20px;
    font-weight: 500;
  }
`;
